export default __webpack_public_path__ + "static/media/bg-value-Collaboration.aef9b542.jpg";